import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    navigationBottom: {
        
        [theme.breakpoints.up("lg")]: {
       
            width: 200  ,
            justifyContent: "space-between",
            marginTop : 6
                                      },
            },
        container: {
            display: (props) => (props.open ? "flex" : "none"),
            width: '200 px',
            position: "absolute",
               top: 60,
               right :50 ,
              
           
             
             
             
            
             
          },
          buttomContainer : {
            justifyContent: "space-between" ,
               [theme.breakpoints.up("lg")]: {
                 marginLeft : -30

               
                                            },
                [theme.breakpoints.down("lg")]: {
                     width : "20 px"
                               
                                              
                         },                            
                },
                
            

    
   
   
  }));


export { useStyles };